export const POSITIONAL_SUFFIXES = {
  one: 'ST',
  two: 'ND',
  few: 'RD',
  other: 'TH',
};